<template>

<div class="advanced-switch">

	<div class="advanced-switch-item" :class="{'is-active': mode === 1}" v-on:click="onClick(1)">
		<span>Standard</span>
		<span v-if="normalCount" class="is-count">{{ normalCount }}</span>
	</div>

	<div class="advanced-switch-item" :class="{'is-active': mode === 2}" v-on:click="onClick(2)">
		<span>Advanced</span>
		<span v-if="advancedCount" class="is-count">{{ advancedCount }}</span>
	</div>

</div>

</template>

<script>

export default {

    props: ['mode', 'filter'],

	computed: {

		advancedCount: function() {

			return this.$store.getters['filter/' + this.filter + '/advanced/count']

		},

		normalCount: function() {

			return this.$store.getters['filter/' + this.filter + '/active/count'] - this.advancedCount

		}

	},

    methods: {

        onClick: function(n) {

            this.$emit('change', n)

        }

    }

}

</script>

<style scoped>

.advanced-switch {
	display: grid;
	width: 100%;
	grid-template-columns: 1fr 1fr;
	background-color: #4b7185;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border-bottom: 1px solid #2b5870;
	z-index: 300;
}

.advanced-switch-item {
	font-size: 16px;
	height: 48px;
	line-height: 48px;
	user-select: none;
	cursor: pointer;
	color: #fff;
	font-weight: 400;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	border-bottom: 4px solid transparent;
}

.advanced-switch-item:hover {
	border-bottom: 4px solid #fff;
	color: #fff;
}

.advanced-switch-item.is-active,
.advanced-switch-item.is-active:hover {
	border-bottom: 4px solid #ffc563;
	color: #ffc563;
	font-weight: 500;
}

.advanced-switch-item .is-count {
	background-color: #fff;
    border-radius: 4px;
    color: #333;
    font-size: 12px;
    min-width: 16px;
    height: 16px;
    padding: 0px 4px;
	box-sizing: border-box;
    text-align: center;
    font-weight: 500;
    line-height: 16px;
}

.advanced-switch-item.is-active .is-count {
	background-color: #ffc563;
}

</style>